/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';
import { forwardRef } from 'react';

import { TextField } from '@coursera/cds-core';
import type { TextFieldProps } from '@coursera/cds-core';

import _t from 'i18n!nls/authentication';

type PropsFromCaller = {
  label?: string;
  name?: string;
  placeholder?: string;
};

type PropsToComponent = PropsFromCaller &
  Omit<TextFieldProps, keyof PropsFromCaller> & {
    value?: string | number;
    defaultValue?: string | number;
  };

const TwoFactorAuthInput = forwardRef<HTMLInputElement, PropsToComponent>(
  (
    { label = _t('Verification Code'), name = 'one-time-password', placeholder = _t('000000'), autoFocus, ...props },
    ref
  ) => {
    return (
      <TextField
        {...props}
        autoFocus={autoFocus}
        label={label}
        name={name}
        placeholder={placeholder}
        ref={ref}
        autoComplete="one-time-code"
        optional={false}
        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
      />
    );
  }
);
export default TwoFactorAuthInput;
